<div class="page-wrapper auth-bg">
    <div class="authentication-box">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 p-0 card-right">
                    <div class="card">
                        <div class="card-body">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-12 d-flex align-items-center justify-content-between">
                                        <h6 class="b-title">Enter the class code</h6>
                                        <img alt="" src="assets/images/EdQuill.png" style="width: auto; height: 32px;">
                                    </div>
                                    <div class="col-12 mt-2 d-flex justify-content-around">
                                        <div class="card col-12 p-4">
                                            <input class="form-control" [(ngModel)]="classCode" maxlength="10"
                                                placeholder="Enter the class code">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <!-- <div class="col-6">
                                        <a title="Home-Page" [routerLink]="'/auth/login'">
                                            <app-feather-icons [icon]="'home'"></app-feather-icons>
                                        </a>
                                    </div> -->
                                    <div class="col-6">
                                        <button type="button" class="btn btn-outline-primary  py-1 px-3"
                                            [routerLink]="'/auth/login'">Home</button>
                                    </div>
                                    <div class="col-6 text-right">
                                        <button type="button" class="btn btn-primary py-1 px-3"
                                            (click)="enrollClassLogin()">Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Login Template-->
<ng-template #loginTemplate let c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="r-title">Login</h4>
        <i class="fa fa-close fa-lg mt-1" aria-hidden="true" style="color:#7F3486; cursor: pointer; float: right;"
            (click)="close()"></i>
    </div>
    <div class="modal-body">
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <form [formGroup]="loginForm">
                        <div class="form-group">
                            <input #userNameFocus autofocus required="" name="login[username]" type="email" class="form-control"
                                placeholder="Email" autocomplete="new-user" formControlName="userName">
                            <em class="error"
                                *ngIf="!loginForm.get('userName').valid && (loginForm.get('userName').dirty || loginForm.get('userName').touched)">Email
                                is required</em>
                        </div>
                        <div class="form-group">
                            <div class="input-group">
                                <input required="" name="login[password]" type="text" formControlName="password"
                                    class="form-control" placeholder="Password" aria-label="Recipient's username"
                                    aria-describedby="basic-addon1" autocomplete="new-pass"
                                    [type]="conps ? 'password' : 'text'">
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon2">
                                        <i [class]="conps ? 'fa fa-eye-slash' : 'fa fa-eye'" aria-hidden="true"
                                            (click)="conps = !conps"></i>
                                    </span>
                                </div>
                            </div>
                            <em class="error"
                                *ngIf="!loginForm.get('password').valid && (loginForm.get('password').dirty || loginForm.get('password').touched)">Password
                                is required</em>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="newRegister()">New Register</button>
        <button type="button" class="btn btn-success-gradien" (click)="submitLoginForm()">Submit</button>
    </div>
</ng-template>

<!--Register Template-->
<ng-template #registerTemplate let c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="r-title">Register</h4>
        <i class="fa fa-close fa-lg mt-1" aria-hidden="true" style="color:#7F3486; cursor: pointer; float: right;"
            (click)="exit()"></i>
    </div>
    <div class="modal-body">
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <form [formGroup]="registerForm">
                        <div class="form-group row">
                            <label for="validationCustom0" class="col-xl-3 col-md-4"><span>*</span>
                                First Name</label>
                            <div class="col-xl-8 col-md-7">
                                <input class="form-control" formControlName="first_name" id="validationCustom0"
                                    type="text" placeholder="First Name" required="">
                                <em class="error"
                                    *ngIf="!registerForm.get('first_name').valid && (registerForm.get('first_name').dirty || registerForm.get('first_name').touched)">First
                                    name is required</em>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="validationCustom1" class="col-xl-3 col-md-4"><span>*</span>
                                Last Name</label>
                            <div class="col-xl-8 col-md-7">
                                <input class="form-control " formControlName="last_name" id="validationCustom1"
                                    type="text" placeholder="Last Name" required="">
                                <em class="error"
                                    *ngIf="!registerForm.get('last_name').valid && (registerForm.get('last_name').dirty || registerForm.get('last_name').touched)">Last
                                    name is required</em>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="validationCustom07" class="col-xl-3 col-md-4"><span
                                    style="visibility: hidden">*</span>
                                Gender</label>
                            <div class="col-xl-8 col-md-7">
                                <select class="form-control" formControlName="gender" id="validationCustom07">
                                    <option value="">Select Gender</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                    <option value="n/a">Do not want to disclose</option>
                                </select>
                                <em class="error"
                                    *ngIf="!registerForm.get('gender').valid && (registerForm.get('gender').dirty || registerForm.get('gender').touched)">Gender
                                    is required</em>
                            </div>
                        </div>
                        <!--                        <div class="form-group row">-->
                        <!--                            <label class="col-xl-3 col-md-4"><span>*</span>-->
                        <!--                                Grade</label>-->
                        <!--                            <div class="col-xl-8 col-md-7">-->
                        <!--                                <ng-select [items]="gradeData"-->
                        <!--                                           bindLabel="grade_name"-->
                        <!--                                           bindValue="grade_id"-->
                        <!--                                           formControlName="grade"-->
                        <!--                                           placeholder="Please Select"-->
                        <!--                                           typeToSearchText=""-->
                        <!--                                >-->
                        <!--                                </ng-select>-->
                        <!--                                <em class="error"-->
                        <!--                                    *ngIf="!registerForm.get('grade').valid && (registerForm.get('grade').dirty || registerForm.get('grade').touched)">Grade-->
                        <!--                                    is required</em>-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                        <div class="form-group row">
                            <label for="validationCustom5" class="col-xl-3 col-md-4"><span>*</span>
                                Email Address</label>
                            <div class="col-xl-8 col-md-7">
                                <input class="form-control" formControlName="email_id" id="validationCustom5"
                                    type="email" placeholder="Email" autocomplete="off" required="">
                                <em class="error"
                                    *ngIf="!registerForm.get('email_id').valid && (registerForm.get('email_id').dirty || registerForm.get('email_id').touched)">Email
                                    is required</em>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-xl-3 col-md-4"><span>*</span>
                                Password</label>
                            <div class="col-xl-8 col-md-7">
                                <div class="input-group">
                                    <input type="text" formControlName="password" class="form-control"
                                        placeholder="Password" autocomplete="new-password"
                                        [type]="conps ? 'password' : 'text'">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon3">
                                            <i [class]="conps ? 'fa fa-eye-slash' : 'fa fa-eye'" aria-hidden="true"
                                                (click)="conps = !conps"></i>
                                        </span>
                                    </div>
                                </div>
                                <em class="error"
                                    *ngIf="!registerForm.get('password').valid && (registerForm.get('password').dirty || registerForm.get('password').touched)">Password
                                    is required</em>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="validationCustom5" class="col-xl-3 col-md-4"><span>*</span>
                                Confirm Password</label>
                            <div class="col-xl-8 col-md-7">
                                <div class="input-group">
                                    <input required="" type="text" formControlName="confirmpassword"
                                        class="form-control" placeholder="Confirm Password"
                                        aria-label="Recipient's username" aria-describedby="basic-addon1"
                                        [type]="conps1 ? 'password' : 'text'">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon4">
                                            <i [class]="conps1 ? 'fa fa-eye-slash' : 'fa fa-eye'" style="color: #7F3486"
                                                aria-hidden="true" (click)="conps1 = !conps1"></i>
                                        </span>
                                    </div>
                                </div>
                                <div *ngIf="checkPasswords()">
                                    <em class="error help-block">
                                        Enter same password as above
                                    </em>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="col-12 d-flex">
            <div class="col-4">
                <button class="btn btn-primary" (click)="exit()">
                    <i class="fa fa-long-arrow-left fa-1x mr-2" aria-hidden="true"></i>Back to login
                </button>
            </div>
            <div class="col-8 d-flex justify-content-end">
                <button type="button" class="btn btn-danger-gradien" (click)="formresetValue()">Reset</button>
                <button class="btn btn-success-gradien ml-2" (click)="submitRegisterForm()"
                    type="button">Submit</button>
            </div>
        </div>
    </div>
</ng-template>
